import { z } from "zod";

export const eventBookingRequestSchema = z.object({
  eventType: z.string().min(1, "Event type is required"),
  date: z.string().min(1, "Date is required"),
  time: z.string().min(1, "Time is required"),
  location: z.string().min(1, "Location is required"),
  guestCount: z.number().positive().optional(),
  powerAccess: z.string().optional(),
  name: z.string().min(1, "Name is required"),
  email: z.string().email("Valid email is required"),
  phone: z.string().min(1, "Phone number is required"),
  notes: z.string().optional(),
});

export const eventTypeOptionSchema = z.object({
  label: z.string().min(1),
  description: z.string().optional(),
  icon: z.string().optional(),
});

export const eventBookingSectionContentSchema = z.object({
  title: z.string().min(1, "Title is required"),
  subtitle: z.string().optional(),
  emailTo: z.string().email("Valid email is required"),
  eventTypes: z.array(eventTypeOptionSchema).min(1, "At least one event type required"),
  ctaText: z.string().optional(),
  successMessage: z.string().optional(),
  confirmationHref: z.string().optional(),
  confirmationLabel: z.string().optional(),
  variant: z.enum(["simple", "funnel"]).optional(),
});
